import React, {useState, useEffect} from "react";
import styles from "./login.module.css";
import { HiOutlineEnvelope, HiOutlineKey } from "react-icons/hi2";
import axios from "axios";
import { Url, setUser } from "../../Constants/globals";
import me from "../../Components/Me/me";
import Alert from "../../Components/Alert/alert";
import Loading from "../../Components/Loading/loading";

function Login() {

  const [loading, setLoading] = useState("");
  const [alert, setAlert] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [wrongPassword, setWrongPassword] = useState(parseInt(localStorage.getItem("invalid")));
  const [timeLeft, setTimeLeft] = useState(parseInt(localStorage.getItem("invalid_time")) !==  null ? parseInt(localStorage.getItem("invalid_time")) : 40);

  useEffect(() => {
    if (!localStorage.getItem("invalid") || parseInt(localStorage.getItem("invalid")) < 0){
      localStorage.setItem("invalid", 0);
      setWrongPassword(0);
    }
    else {
      setWrongPassword(parseInt(localStorage.getItem("invalid")));
    }
    if (parseInt(localStorage.getItem("invalid")) >= 5){
      if (timeLeft === 0){
        return;
      }
      const intervalId = setInterval(() => {
        let timeLeft2 = timeLeft - 1;
        setTimeLeft(timeLeft2);
        localStorage.setItem("invalid_time", timeLeft2);
      }, 1000);
      return () => clearInterval(intervalId);
    }
  }, [timeLeft, wrongPassword]);

  const increasePunishment = (value) => {
    setWrongPassword(value);
    localStorage.setItem("invalid", value);
    if (value >= 5){
      setTimeLeft(40);
    }
    return;
  }

  const handleLogin = async () => {
    await setAlert("");
    if (email.trim().length === 0){
      return setAlert(<Alert type={"error"}>Introduza um email válido</Alert>);
    }
    if (password.length === 0){
      return setAlert(<Alert type={"error"}>Password incorreta</Alert>);
    }
    await setLoading(<Loading/>);
    const logged = await login(email, password);
    if (logged[0]){
      var me2 = await me();
      localStorage.setItem("invalid", 0);
      localStorage.setItem("invalid_time", 0);
      if(me2) window.location = "/menu";
    }
    else {
      setLoading("");
      if (logged[1] === "Estas credenciais não coincidem com os nossos registos."){
        increasePunishment(wrongPassword+1);
      }
      localStorage.removeItem("user");
      return setAlert(<Alert type="error">{logged[1]}</Alert>);
    }
  };

  const login = async (email, pass) => {
    try {
      const res = await axios.post(Url + "/authentication", {
        email: email,
        password: pass,
      });
      localStorage.setItem("user", JSON.stringify(res.data));
      setUser(res.data);
      return [true];
    }
    catch (err) {
      if (err?.request?.status === 408 || err?.message === "Network Error"){
        return [false, "Não foi possível conectar ao servidor. Verifique a sua ligação de rede."];
      }
      else if (err?.response?.data?.detail === "Estas credenciais não coincidem com os nossos registos."){
        return [false, "Estas credenciais não coincidem com os nossos registos."]
      }
      return [false, err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro de ligação com o servidor."];
    }
  };

  return (
    <div className={styles.body}>
      {loading}
      {alert}
      <div className={styles.blur}/>
      <div className={styles.center}>
        <div className={styles.box}>
          <div className={styles.logo}/>
          <div className={styles.column}>
            <div className={styles.boxInput}>
              <HiOutlineEnvelope className={styles.iconsColor} />
              <input
                className={styles.inputText}
                placeholder={"Email"}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    handleLogin();
                  }
                }}
              />
            </div>
            <div className={styles.boxInput}>
              <HiOutlineKey className={styles.iconsColor} />
              <input
                type={"password"}
                className={styles.inputText}
                placeholder={"Password"}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(event) => {
                  if (event.key === "Enter") handleLogin();
                }}
              />
            </div>
            {
              parseInt(timeLeft) > 0 ?
                <div>
                  <p className={styles.timer}>Demasiadas tentativas erradas.</p>
                  <p className={styles.timer}>Aguarde {timeLeft} segundos...</p>
                </div>
              :""
            }
          </div>
          <div className={styles.columnBtn}>
            <button disabled={parseInt(timeLeft) > 0} style={parseInt(timeLeft) > 0 ? {cursor: "not-allowed"} : {}} className={styles.btn} onClick={() => handleLogin()}>
              Iniciar sessão
            </button>
            <div className={styles.centerText}>
              <span onClick={() => window.location = "/recover-password"}>Recuperar palavra-passe</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;